import {} from "whatwg-fetch";
import FrusterError from "../model/FrusterError";

class APIClient {
    
    constructor(apiRoot = "https://pu-api-gateway.production.paceup.io" || "") {
        this.apiRoot = apiRoot;        
    }
    
    acceptInvitation(token, email) {
        return this.post("/group/accept-invitation", { token, email });            
    }

    // -------------------

    get(path, query) {
        return this.doFetch("GET", path, query);
    }

    post(path, jsonBody) {
        return this.doFetch("POST", path, {}, jsonBody);
    }

    put(path, jsonBody) {
        return this.doFetch("PUT", path, {}, jsonBody);
    }

    delete(path, query) {
        return this.doFetch("DELETE", path, query);
    }

    doFetch(method, path, query, jsonBody) {
        const reqOpts = {
            method: method,
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            mode: "cors",
            credentials: "include",
            body: JSON.stringify(jsonBody)
        };

        const url = this.createUrl(path, query);
        const req = new Request(url, reqOpts);

        return fetch(req)
            .then(res => {
                return res.json().then(json => {
                    // Fetch API always enters success even though an error
                    // was returned. Check this here and throw error to be able
                    // to .catch error later in promise chain.

                    if (!res.ok) {
                        throw new FrusterError(json);
                    }
                    return json.data;
                })
            });            
    }

    doMultipartUpload(path, file) {
        let formData = new FormData();
        formData.append("file", file);

        const reqOpts = {
            method: "POST",
            // headers: new Headers({
            //     "Content-Type": "application/json"
            // }),
            mode: "cors",            
            body: formData
        };
        
        const url = this.createUrl(path);
        const req = new Request(url, reqOpts);

        return fetch(req)
            .then(res => {
                return res.json().then(json => {
                    // Fetch API always enters success even though an error
                    // was returned. Check this here and throw error to be able
                    // to .catch error later in promise chain.

                    if (!res.ok) {
                        throw new FrusterError(json);
                    }
                    return json.data;
                })
            });    
    }

    createUrl(path, query = {}) {
        let url = this.apiRoot + path;

        if(Object.keys(query)) {
            url += "?";

            Object.keys(query).forEach(key => {
                
                if (query[key] !== undefined) {
                    url += (key + "=" + query[key] + "&");
                }
                
            });

            url = url.slice(0, -1); // remove last &
        }

        return url;
    }
}

export default new APIClient();



// WEBPACK FOOTER //
// ./src/networking/APIClient.js